var EmailAnalyticsData = /** @class */ (function () {
    function EmailAnalyticsData(selectedTemplate, edited) {
        if (selectedTemplate === void 0) { selectedTemplate = null; }
        if (edited === void 0) { edited = false; }
        this.selectedTemplate = selectedTemplate;
        this.edited = edited;
    }
    EmailAnalyticsData.prototype.setEmailTemplateEdited = function () {
        this.edited = !!this.selectedTemplate;
    };
    EmailAnalyticsData.prototype.reset = function () {
        this.edited = false;
        this.selectedTemplate = null;
    };
    return EmailAnalyticsData;
}());
export { EmailAnalyticsData };
